// extracted by mini-css-extract-plugin
export var cardLayout = "_6v-1";
export var paginationContainer = "_6v-0";